exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".base-timer[data-v-6b4f05c8]{position:relative;width:40px;height:40px}.base-timer__svg[data-v-6b4f05c8]{transform:scaleX(-1)}.base-timer__circle[data-v-6b4f05c8]{fill:none;stroke:none}.base-timer__path-elapsed[data-v-6b4f05c8]{stroke-width:7px;stroke:#fff}.base-timer__path-remaining[data-v-6b4f05c8]{stroke-width:7px;stroke-linecap:round;transform:rotate(90deg);transform-origin:center;transition:all 1s linear;fill-rule:nonzero;stroke:currentColor}.base-timer__path-remaining.green[data-v-6b4f05c8]{color:#41b883}.base-timer__path-remaining.orange[data-v-6b4f05c8]{color:orange}.base-timer__path-remaining.red[data-v-6b4f05c8]{color:red}.base-timer__label[data-v-6b4f05c8]{position:absolute;width:40px;height:40px;top:0;display:flex;align-items:center;justify-content:center;font-size:8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6b4f05c8","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/BaseTimer.vue
// module id = 851
// module chunks = 0